import { useActivation } from '@context/MobileOne';
import { Feedback, ScrollToTop } from '@core/index';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { appButtonType, appIconsPath } from '@utils/globalConstant';

export const EmailVerificationCodeSuccess = () => {
  const { nextStep, setShowActivationHeader } = useActivation();

  // Const
  const headerContent = tA11y('ek_reg_2fa_suc_hdl1');
  const copyTextContent = tA11y('ek_reg_2fa_suc_txt1');
  const buttonContent = tA11y('ek_reg_2fa_suc_btn1');

  return (
    <>
      <ScrollToTop>
        <Feedback
          icon='SUCCESS'
          headingContent={headerContent}
          copyTextContent={copyTextContent}
          buttonContent={buttonContent}
          buttonType={appButtonType.PRIMARY}
          buttonIcon={appIconsPath.ARROW_RIGHT}
          buttonClick={() => {
            nextStep();
            setShowActivationHeader(true);
          }}
        />
      </ScrollToTop>
    </>
  );
};

export default EmailVerificationCodeSuccess;
